import { render, staticRenderFns } from "./DataProduk.vue?vue&type=template&id=6b7b3bcc&scoped=true&"
import script from "./DataProduk.vue?vue&type=script&lang=js&"
export * from "./DataProduk.vue?vue&type=script&lang=js&"
import style0 from "./DataProduk.vue?vue&type=style&index=0&id=6b7b3bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b3bcc",
  null
  
)

export default component.exports